import { NgModule } from '@angular/core';
import { BreadcrumbItemComponent } from './breadcrumb-item.component';

@NgModule({
  imports: [BreadcrumbItemComponent],
  exports: [BreadcrumbItemComponent]
})
export class BreadcrumbItemModule {}
